<template>
  <div class="review page">
    <div class="page-header">
      <div class="container">
        <h1 class="title">{{ $t('pagetitle.history') }}</h1>
      </div>
    </div>
    <div class="page-body" v-loading="loading">
      <div class="container">
        <div v-if="($mq.resize && $mq.below('767px'))" :style="{ paddingBottom: '5px' }">
          <span class="title">{{ $t('title.purchaseorder') }}: {{ orderno }}
          </span>
        </div>
        <div class="orderheader">
          <span v-if="!($mq.resize && $mq.below('767px'))" class="title">{{ $t('title.purchaseorder') }}: {{ orderno }}
          </span>
          <div class="orderheader-right">
            <span v-if="status" :class="['css' + this.orderStatus[this.status]]">{{ this.orderStatus[this.status] }}</span>
            <el-button icon="el-icon-download" v-if="this.popdf" class="orange-download-button" @click="onDownloadClick()">
              {{ $t('button.download') }}
            </el-button>
            <span class="date" v-if="date">{{ date }}</span>
          </div>
        </div>
        <div class="address">
          <div class="address-row">
            <div class="item">
              <div class="item-padding" v-if="billing">
                <div class="item-title">
                  <span class="title">Billing Address</span>
                </div>
                <h2 style="font-weight: bold">{{ billing.branch }}</h2>
                <h2>{{ billing.address1 }}</h2>
                <h2 v-if="billing.address2">{{ billing.address2 }}</h2>
                <h2>{{ billing.postcode }}, {{ billing.city }}</h2>
                <h2>{{ billing.state }}, {{ billing.country }}</h2>
              </div>
            </div>
            <div class="item">
              <div class="item-padding" v-if="address">
                <div class="item-title">
                  <span class="title">Deliver Address</span>
                </div>
                <h2 style="font-weight: bold">{{ address.branch }}</h2>
                <h2>{{ address.address1 }}</h2>
                <h2 v-if="address.address2">{{ address.address2 }}</h2>
                <h2>{{ address.postcode }}, {{ address.city }}</h2>
                <h2>{{ address.state }}, {{ address.country }}</h2>
              </div>
            </div>
          </div>
        </div>
        <el-row class="product">
          <el-table
            :data="products"
            style="width: 100%">
            <el-table-column
              type="index"
              width="50">
            </el-table-column>
            <el-table-column
              width="150px">
              <template slot-scope="scope">
                <img class="product-img" :src="scope.row.beerImage ? scope.row.beerImage : '/static/beer-placeholder.jpg'" />
              </template>
            </el-table-column>
            <el-table-column
              prop="beer"
              label="Beer">
            </el-table-column>
            <el-table-column
              prop="brewery"
              label="Brewery">
            </el-table-column>
            <el-table-column
              prop="price"
              label="Unit Price"
              width="150px">
            </el-table-column>
            <el-table-column
              prop="quantity"
              label="Quantity"
              width="150px">
            </el-table-column>
            <el-table-column
              prop="total"
              label="Sub-Total"
              width="150px">
            </el-table-column>
          </el-table>
          <el-alert
            class="error-alert"
            v-for="(err, index) in errorMsg"
            :key="index"
            :title="err.msg"
            :type="err.icon"
            show-icon>
          </el-alert>
          <el-row class="action">
            <el-button class="orange-button" @click="onSubmit($t('button.confirm'))">
              {{ $t('button.reorder') }}
            </el-button>
          </el-row>
        </el-row>
      </div>
    </div>
  </div>
</template>

<script>
import Site from '@/api/site'
export default {
  name: 'cart',
  components: {
  },
  props: {
    id: {
      default: undefined
    }
  },
  data () {
    return {
      orderno: '',
      products: [],
      address: undefined,
      billing: undefined,
      popdf: undefined,
      loading: false,
      status: undefined,
      date: undefined,
      orderStatus: [
        'Pending',
        'Processing',
        'Completed',
        'Closed',
        'Cancelled',
        'On Hold'
      ],
      isError: false,
      errorMsg: []
    }
  },
  created () {
  },
  mounted () {
    this.onLoad()
  },
  methods: {
    onLoad () {
      if (!this.id) {
        this.$router.replace({ name: this.$t('route.orders') })
        return
      }
      this.loading = true
      const data = { id: this.id, userId: this.$store.getters.id }
      Site.getUserOrderById(data).then((res) => {
        const resOrder = res.result
        this.address = resOrder.address
        this.billing = resOrder.userinfo.billing
        this.orderno = resOrder.po_number
        this.popdf = resOrder.popdf
        this.status = resOrder.status

        const locale = this.$moment(resOrder.created_at + ' +0000', 'YYYY-MM-DD HH:mm:ss Z').tz('Asia/Kuala_Lumpur').format('DD/MM/YYYY')
        this.date = locale
        const inventory = resOrder.inventory
        inventory.forEach((item) => {
          let obj = {
            id: item.id,
            beer: item.description,
            brewery: item.description2,
            price: this.$t('currency.malaysia') + ' ' + item.unit_price.toFixed(2),
            quantity: item.quantity,
            total: this.$t('currency.malaysia') + ' ' + item.price.toFixed(2),
            beerImage: item.beer_image ? item.beer_image.path : ''
          }
          this.products.push(obj)
        })
        this.loading = false
      }).catch((err) => {
        console.log(err)
        this.loading = false
      })
    },
    onSubmit () {
      let ids = []
      this.products.forEach((item) => {
        ids.push(item.id)
      })
      const data = { ids, groupId: this.$store.getters.groupid }
      this.getBeer(data)
    },
    getBeer (data) {
      this.isError = false
      this.errorMsg = []
      Site.getBeer(undefined, data).then((res) => {
        // console.log(res)
        this.products.forEach((item) => {
          let data
          res.result.forEach((val) => {
            let promoprice
            let userprice
            val.prices.forEach((price) => {
              if (price.uom === 'BOTTLE') {
                if (price.group && price.group.xml_name === 'PROMO') {
                  promoprice = price.stockvalue
                } else {
                  userprice = price.stockvalue
                }
              } else if (price.uom === 'KEG') {
                if (price.group && price.group.xml_name === 'PROMO') {
                  promoprice = price.stockvalue
                } else {
                  userprice = price.stockvalue
                }
              }
            })
            val.user_price = promoprice !== undefined ? promoprice : (userprice !== undefined ? userprice : val.refprice)

            // this.products.forEach((item) => {
            //   if (val.id === item.id) {
            //     const data = { beer: val, quantity: item.quantity }
            //     this.$store.dispatch('AddBeer', data).then(() => {
            //       console.log('ok')
            //     }).catch(err => {
            //       console.log(err)
            //     })
            //   }
            // })
            if (val.id === item.id) {
              data = { beer: val, quantity: item.quantity }
            }
          })
          if (data) {
            if (data.beer.balsqty < item.quantity) {
              const obj = {
                icon: 'warning',
                msg: item.beer + ' added, only ' + data.beer.balsqty + ' quantity available.'
              }
              this.errorMsg.push(obj)
            }
            this.$store.dispatch('AddBeer', data).then(() => {
            }).catch(err => {
              console.log(err)
            })
          } else {
            const obj = {
              icon: 'error',
              msg: item.beer + ' failed to add, this product is currently out of stock and unavailable.'
            }
            this.errorMsg.push(obj)
          }
        })
      }).catch((err) => {
        console.log(err)
      })
    },
    onDownloadClick () {
      if (this.popdf && this.popdf.path) {
        window.open(this.popdf.path, '_blank')
      }
    }
  }
}
</script>
<style lang="scss">
@import "@/styles/settings.scss";
.review {
  .el-table thead {
    & > tr > th {
      border-bottom: 1px solid $dark-gray-color;
      & > .cell {
        color: $dark-gray-color;
      }
    }
  }
  .el-table__body-wrapper {
    padding-bottom: 1px;
  }
  .el-table__row {
    & > td {
      border-bottom: 1px solid $gray-color;
      & > .cell {
        color: $dark-gray-color;
      }
    }
  }
  .el-table, .el-table th, .el-table tr {
    background-color: transparent;
  }
}
</style>
<style lang="scss" scoped>
@import "@/styles/settings.scss";
.review {
  .error-alert {
    margin-top: 5px;
  }
  .cssPending, .cssProcessing {
    font-size: 14px;
    font-family: Arial;
    font-family: Arial;
    padding: 5px 10px;
    border-radius: 5px;
    color: $white-color;
    background-color: $warning-color;
  }
  .cssClosed {
    font-size: 14px;
    font-family: Arial;
    padding: 5px 10px;
    border-radius: 5px;
    color: $white-color;
    background-color: $info-color;
  }
  .cssComplete {
    font-size: 14px;
    font-family: Arial;
    padding: 5px 10px;
    border-radius: 5px;
    color: $white-color;
    background-color: $success-color;
  }
  .cssCancelled {
    font-size: 14px;
    font-family: Arial;
    padding: 5px 10px;
    border-radius: 5px;
    color: $white-color;
    background-color: $danger-color;
  }
  .container {
  }
  .page-body {
    background-color: $white-color;
  }
  .orderheader {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    padding-bottom: 10px;
    margin-bottom: 15px;
    border-bottom: 1px solid $black-color;
    & > .title {
      font-size: 20px;
    }
    .orderheader-right {
      .date {
        padding: 0 15px;
      }
    }
    .orange-download-button {
      padding: 5px 10px;
    }
  }
  .action {
    display: flex;
    justify-content: flex-end;
    padding: 20px 0;
  }
  .product {
    padding-bottom: 50px;
  }
  .total {
    display: flex;
    justify-content: flex-end;
    & > .title {
      font-weight: bold;
      padding-right: 15px;
    }
  }
  .product-img {
    width: 130px;
    height: 130px;
  }
  .product-list {
    display: flex;
    flex-direction: row;
    padding: 15px 0;
    border-bottom: 2px solid $gray-color;
    & > img {
      height: 100px;
      margin-right: 15px;
    }
    .product-desc {
      display: flex;
      flex-direction: row;
      width: 100%;
      .title {
        font-size: 16px;
        font-weight: bold;
        padding-bottom: 5px;
      }
      .product-qty, .product-price, .product-name {
        display: flex;
        flex-direction: column;
      }
      .product-name {
        width: 100%;
      }
      .product-qty {
        display: flex;
        align-items: center;
        width: 100px;
      }
      .product-price {
        display: flex;
        align-items: center;
        width: 150px;
      }
      .product-col {
        display: flex;
        flex-direction: row;
      }
    }
  }
  .address-row {
    width: 100%;
    display: flex;
    align-items: left;
    justify-content: left;
    flex-direction: row;
    flex-wrap: wrap;
    flex-flow: row wrap;
    align-content: flex-end;
    // column-count: 1;
    @media (min-width: 768px) {
      // column-count: 3;
    }
    .item {
      display: flex;
      width: 50%;

      @media (min-width: 768px) {
        width: 33%;
      }
      &.active {
        & > .item-padding {
          border-color: $orange-light-color;
        }
      }
      .item-padding {
        & > .item-title {
          font-weight: bold;
        }
        display: flex;
        flex-direction: column;
        width: 100%;
        border: 1px solid $gray-color;
        border-radius: 3px;
        background-color: $white-color;
        margin: 5px;
        padding: 10px;
      }
      h1 {
        font-size: 18px;
      }
      h2 {
        font-size: 16px;
        font-weight: normal;
        margin: 5px 0;
      }
      img {
        width: 100%;
        max-width: 100%;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/views/orders/orderdetails.vue